import React, { useState, useEffect } from "react";
import "./Slider.css";

const Slider = ({ children, interval = 40000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide functionality
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === children.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(slideInterval); // Cleanup interval on component unmount
  }, [children, interval]);

  // Handle slide change on clicking indicators
  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slider-with-indicator">
      <div className="slider-with-wrapper">
        {React.Children.map(children, (child, index) => (
          <div
            key={index}
            className={`slide-me ${index === currentIndex ? "slide-me-active" : ""}`}
          >
            {index === currentIndex && child}
          </div>
        ))}
      </div>

      {/* Circular Indicators */}
      <div className="slider-with-indicator-indicators">
        {children.map((_, index) => (
          <div
            key={index}
            className={`indicator-dots ${
              index === currentIndex ? "active-indicator-dots" : ""
            }`}
            onClick={() => handleIndicatorClick(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
